import { gql } from '@apollo/client'

export const GET_WORKSPACE_TOKEN = gql`
  query getWorkspaceToken {
    generateWorkspaceJwt
  }
`
